import { Timestamp } from 'firebase/firestore';

/**
 * Get activity icon based on activity type
 */
export function getActivityIcon(activityType: string): string {
  if (activityType.includes('rock')) return '🎯';
  if (activityType.includes('issue')) return '⚠️';
  if (activityType.includes('action_item') || activityType.includes('todo')) return '✓';
  if (activityType.includes('metric')) return '📊';
  if (activityType.includes('wins_excited')) return '🎉';
  return '📝';
}

/**
 * Get activity color classes based on activity type
 * Returns Chakra UI color scheme names
 */
export function getActivityColor(activityType: string): {
  colorScheme: string;
  bgColor: string;
  borderColor: string;
} {
  if (
    activityType.includes('completed') ||
    activityType.includes('resolved') ||
    activityType.includes('achieved')
  ) {
    return {
      colorScheme: 'green',
      bgColor: 'green.50',
      borderColor: 'green.200',
    };
  }
  if (activityType.includes('dropped')) {
    return {
      colorScheme: 'red',
      bgColor: 'red.50',
      borderColor: 'red.200',
    };
  }
  if (activityType.includes('created')) {
    return {
      colorScheme: 'blue',
      bgColor: 'blue.50',
      borderColor: 'blue.200',
    };
  }
  return {
    colorScheme: 'gray',
    bgColor: 'gray.50',
    borderColor: 'gray.200',
  };
}

/**
 * Format timestamp to relative time (e.g., "2h ago", "3d ago")
 */
export function formatTimestamp(timestamp: Timestamp | Date | string): string {
  let date: Date;
  
  if (timestamp instanceof Timestamp) {
    date = timestamp.toDate();
  } else if (timestamp instanceof Date) {
    date = timestamp;
  } else {
    date = new Date(timestamp);
  }

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

